import validators from '../../utils/validators';

class CheckupAnswer {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      user: (v) => validators.isNotEmptyString(v),
      createdAt: (v) => validators.isValidDate(v),
      answers: (v) => validators.isArray(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid CheckupAnswer property '${property}' in ${data.id}`);
      }

      if (property === 'answers') {
        this.answers = [];

        for (const answer of data[property]) {
          const {field, value} = answer;

          if (!validators.isNotEmptyString(field)) {
            throw new Error(`Invalid CheckupAnswer answer property 'field' in ${data.id}`);
          }

          if (!validators.isNotEmptyString(value)) {
            throw new Error(`Invalid CheckupAnswer answer property 'value' in ${data.id}`);
          }

          this.answers.push({field, value});
        }
      } else {
        this[property] = data[property];
      }
    }
  }
}

export default CheckupAnswer;
